import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  ButtonGroup as MuiButtonGroup,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import InfoPopover from "../components/InfoPopover.jsx";
import { convertToDefEventPara } from "../helper.js";

ButtonGroup.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function ButtonGroup(props) {
  const {
    item,
    value = false,
    error = null,
    onChange,
    showErrorText = false,
    disabled = false,
  } = props;

  let helperText = "";
  if (showErrorText) helperText = error;

  const handleOnChange = (newValue) => {
    onChange(convertToDefEventPara(item.name, newValue || null));
  };

  return (
    <FormControl {...(error && { error: true })}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        sx={{ mt: "10px", mb: "5px" }}
      >
        <Box display="flex" alignItems="start" justifyContent="space-between">
          <FormLabel>{item.label}</FormLabel>
          <InfoPopover item={item} />
        </Box>
      </Box>
      <MuiButtonGroup variant="outlined">
        {item?.options.map((sitem) => (
          <Button
            key={sitem.key}
            color="primary"
            disabled={disabled}
            onClick={(e) => handleOnChange(sitem.key)}
            variant={sitem.key === value ? "contained" : "outlined"}
          >
            {sitem?.label}
          </Button>
        ))}
      </MuiButtonGroup>

      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
